import FindAllProjects from "@/v2/api/project/FindAll";
import { Project } from "@/v2/types";
import ArFilterCombobox from "../../ui/combo-box/FilterComboBox";

interface ArProjectFilterComboBoxProps {
    value?: string; // The selected employee ID
    onChange?: (employeeId: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    label?: string;
}

export default function ArProjectFilterComboBox({
    value,
    onChange,
    placeholder = "Select Project...",
    disabled = false,
    className,
    label = "Project",
}: ArProjectFilterComboBoxProps) {
    const handleSelect = (item: Project | null) => {
        if (onChange) {
            onChange(item ? item.id : "");
        }
    };

    const renderProjectItem = (project: Project) => (
        <div className="flex flex-col">
            <span>{project.name}</span>

            {project.client && (
                <span className="text-xs text-muted-foreground">
                    Client : {project.client.full_name}
                </span>
            )}
        </div>
    );

    return (
        <ArFilterCombobox<Project>
            label={label}
            labelAlign="items-start"
            queryKey={["ar-projects"]}
            queryFn={async ({ pageParam, search, limit, filter }) =>
                FindAllProjects({
                    skip: pageParam,
                    limit,
                    search,
                    filter,
                })
            }
            getDisplayValue={(project: Project) => project.name}
            renderItem={renderProjectItem}
            placeholder={placeholder}
            searchPlaceholder="Search Project..."
            className={className}
            disabled={disabled}
            onItemSelect={handleSelect}
            defaultValueId={value}
            pageSize={20}
            debounceMs={300}
        />
    );
}
